import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { IMAGES_URL, ALL_SERVICES, PLUS_MEMBERSHIP, COMMON_MODULES, MEMBERSHIP_TYPES } from '@src/app/core/constants';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTabsComponent } from '@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { MiniEnvTestimonialsComponent } from '@src/app/core/shared/components/mini-env/mini-env-testimonials/mini-env-testimonials.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as jetsPizzaJson from '@src/assets/i18n/mini-env/jets-pizza/en.json';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-jets-pizza',
  imports: [...COMMON_MODULES,
            HeadingBlockOneModule,
            IconboxOneModule,
            IconboxTwoModule,
            HeadingBlockFullWidthModule,
            ImageboxOneModule,
            ImageboxFullwidthModule,
            CardboxOneModule,
            BannerOneModule,
            ImageboxBulletScrollComponent,
            MiniEnvHeadingBlockComponent,
            MiniEnvFaqsComponent,
            MiniEnvBannerComponent,
            MiniEnvSubFooterComponent,
            MembershipPlanModule,
            VideoPlayerComponent,
            MiniEnvTestimonialsComponent,
            MiniEnvTallInfoCardComponent,
            MiniEnvBgContentComponent,
            MiniEnvTabsComponent],
  templateUrl: './jets-pizza.component.html',
  styleUrl: './jets-pizza.component.scss'
})
export class JetsPizzaComponent extends CoreClass implements OnInit {
IMAGES_URL: string = IMAGES_URL;
  faqList = [];
  imgSrc = `assets/tenant-assets/mini-env/images/people-in-kitchen.png`;
  bgClass = 'father-child-bg';
  services = ['concierge_healthcare', 'dental_services', 'exclusive_discount'];

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = MEMBERSHIP_TYPES.ADDON_DEFAULT;
  // panes: any[] = [{title: 'Concierge-level Healthcare', active: false},{title: 'Dental Services', active: false},{title: 'Exclusive Discount', active: false}];


  benefits = [
    {
      id: '01',
      title: 'Nationwide Care',
      description: 'Virtual and In-person care, across a complete continuum with doctors, dentists, labs, pharmacies, and more!',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Healthcare with a Concierge',
      description: 'Navigate the complexity of healthcare with a licensed Medic concierge to assist and address any concerns.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Personalized Care',
      description: 'Flexible membership options to fit your lifestyle and medical needs, with options to add family members.',
      bgImage: 'm-shape'
    },
  ];

bannerSlides: any[] = jetsPizzaJson.BANNER.BANNER_SLIDES || [];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.getFAQs();
  }

  buttonAction() {
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  setMiniEnvValues() {
    this.httpService.requestEntity('GET', `assets/tenant-assets/mini-env/${environment.miniEnvFile}`).subscribe((res: any) => {   
      const miniEnvConfig = res?.body;  
      if (miniEnvConfig) {
        this.membershipPlanCode = miniEnvConfig['aquoral'].membershipPlanTypes;
      }
    })
  }

  onSliderBtnAction() {
    this.buttonAction();
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

  getFAQs() {
    const apiUrl = `/assets/i18n/mini-env/jets-pizza/${this.sharedService.currentLanguage}.json`;
    this.httpClient.get(apiUrl).subscribe((json: any) => {
      this.faqList = json.FAQS.FAQ_LIST;
    });
  }

}
